import React from "react";

const Hero: React.FC = () => {
  return (
    <div className="bg-gradient-to-r from-blue-50 to-indigo-100 py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
          <div className="text-center md:text-left">
            <h1 className="text-4xl md:text-5xl font-extrabold text-gray-900 leading-tight">
              Master Chemistry with{" "}
              <span className="text-blue-600">Maraz Sir</span>
            </h1>
            <p className="mt-4 text-xl text-gray-600 max-w-3xl">
              Unlock your potential in chemistry through expert guidance,
              interactive lessons, and proven teaching methods.
            </p>
            <div className="mt-8 flex flex-col sm:flex-row justify-center md:justify-start gap-4">
              <a
                href="#batches"
                className="px-8 py-3 border border-transparent text-base font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 md:py-4 md:text-lg md:px-10 transition duration-300"
              >
                View Batches
              </a>
              <a
                href="#login"
                className="px-8 py-3 border border-transparent text-base font-medium rounded-md text-blue-700 bg-blue-100 hover:bg-blue-200 md:py-4 md:text-lg md:px-10 transition duration-300"
              >
                Enroll Now
              </a>
            </div>
          </div>
          <div className="mt-12 md:mt-0 flex justify-center">
            {/* Placeholder for vector graphics */}
            <div className="w-full max-w-md h-full rounded-lg shadow-md flex items-center justify-center">
              <div className="text-center">
                <img
                  src="assets/images/hero-chem.svg"
                  alt="Chemistry Hero"
                  className="w-full h-full object-cover rounded-lg"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
